import { CommonModel } from '../common';

export enum TermsAndConditionsType {
  BUSINESS_SERVICE_TERMS = 'BUSINESS_SERVICE_TERMS',
  DATA_PROCESSING_TERMS = 'DATA_PROCESSING_TERMS',
  BUSINESS_WALLET_TERMS = 'BUSINESS_WALLET_TERMS',
}
export interface TermsAndConditions {
  type: TermsAndConditionsType;
  fileExtension: string;
  fileName: string;
  isLatest: boolean;
  version: number;
  url: string;
}

export type LatestTermsAndConditions = TermsAndConditions & CommonModel;
